export type Point = { x: number; y: number };

export type KeyPoint = {
  id: string;
  visibility: boolean;
  source: "model" | "user";
  coordinates: Point;
};

export const ANNOTATION_TYPES = {
  KEY_POINTS: "KeyPoints",
  SEGMENTATION: "Segmentation",
  UNKNOWN: "Unknown",
} as const;

export type AnnotationType = (typeof ANNOTATION_TYPES)[keyof typeof ANNOTATION_TYPES];
